import React from "react";
import { CSSColor } from "../constants/colors.ts";
import clsx from "clsx";

type ProjectProps = {
  title: string;
  company: string;
  position: string;
  Logo: React.ElementType;
  descriptionPoints?: string[];
  description?: string;
  accentColor: CSSColor;
  mounted: boolean;
  delay: number;
  nda?: boolean;
  className?: string;
};

const Project = (props: ProjectProps) => {
  const {
    title,
    position,
    Logo,
    descriptionPoints,
    description,
    accentColor,
    mounted,
    delay,
    className,
  } = props;

  return (
    <div
      className={clsx(
        `rounded-xl px-6 pb-5 h-full min-w-64 relative text-left self-center !outline-white/5 !outline-2 !outline !shadow-[0px_15px_15px_-3px_rgba(0,_0,_0,_0.3)] !bg-grey-50/10`,
        className
      )}
      style={
        {
          animationDelay: `${delay}ms`,
          "--accent-color": accentColor,
        } as React.CSSProperties
      }
    >
      <div className="flex flex-row items-center gap-x-4">
        <Logo className="h-12 w-12 text-[var(--accent-color)]" />
        <div className="py-4 text-left transform translate-y-2">
          <h1 className="text-2xl">{title}</h1>
          <h3 className="italic !text-xl !font-light">{position}</h3>
        </div>
      </div>
      {descriptionPoints && (
        <ul className="list-disc px-5 max-h-80 overflow-auto">
          {" "}
          {descriptionPoints?.map((point, i) => (
            <li key={i} className="mb-2 marker:text-[var(--accent-color)] leading-6">
              {point}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default Project;
